import { Routes } from './constants'

export default class BasicRouteBuilder {
	protected route: string = ''

	get root() {
		this.route += Routes.ROOT
		return this
	}

	add(param: string | number) {
		this.route += `/${param}`
		return this
	}

	hash(hash?: Key) {
		if (hash) {
			this.route += `/#${hash}`
		}
		return this
	}

	param(param: string) {
		this.route += `/:${param}`
		return this
	}

	query(query: string) {
		this.route += `?${query}`
		return this
	}

	build() {
		const route = this.route
		this.route = ''
		return route
	}
}
